import { storagePath } from '@helpers/variables'

export const getBookImageUrl = (book) => {
  if (book?.image) return `${storagePath}/${book.image}`

  const section = book?.sections?.find((section) => section.image)

  return section ? `${storagePath}/${section.image}` : null
}

/**
 * Group books by category, in category order. Books without a category end up
 * in a last group where category is null. The order of the books within a
 * group is kept as it came in.
 */
export const groupByCategory = (books) => {
  const groups = books.reduce((acc, book) => {
    const key = book.category?.id ?? 'none'

    if (!acc[key]) {
      acc[key] = { category: book.category ?? null, items: [] }
    }

    acc[key].items.push(book)
    return acc
  }, {})

  return Object.values(groups).sort((a, b) => {
    if (!a.category) return 1
    if (!b.category) return -1
    return (a.category.orderColumn ?? 0) - (b.category.orderColumn ?? 0)
  })
}
